import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import {
  UiMoleculeDialogExportProgressComponent,
  ExportProgressDialogData,
} from '../components/molecules/ui-molecule-dialog-export-progress/ui-molecule-dialog-export-progress.component';

export interface ActiveExportDialog {
  progress$: Subject<number>;
  cancel$: Subject<void>;
  close: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class DialogExportProgressService {
  constructor(private dialog: MatDialog) {}

  open(): ActiveExportDialog {
    const progress$ = new Subject<number>();
    const cancel$ = new Subject<void>();
    const data: ExportProgressDialogData = { progress$, cancel$ };

    const ref: MatDialogRef<UiMoleculeDialogExportProgressComponent> = this.dialog.open(
      UiMoleculeDialogExportProgressComponent,
      {
        panelClass: ['dialog-sm', 'dialog-safe-area', 'dialog-flex'],
        disableClose: true,
        autoFocus: false,
        data,
      },
    );

    return {
      progress$,
      cancel$,
      close: () => ref.close(),
    };
  }
}
